import { render, staticRenderFns } from "./MigracionAjustes.vue?vue&type=template&id=35d37df4"
import script from "./MigracionAjustes.vue?vue&type=script&lang=js"
export * from "./MigracionAjustes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports